import { useState } from 'react';
import Card from '../../../../../../common/components/ContainerCard';
import Modal from '../../../../../../common/components/Modal';
import { IPhone } from '../../../../../../models/Account/IPhone';
import { PhoneNumberType } from '../../../../../../models/enums';
import styles from './PhoneNumberCard.module.css';

type PhoneNumberCardProps = {
  phoneData: IPhone;
  onEdit: (phone: IPhone) => void;
  onDelete: (phoneData: IPhone) => void;
};

const PhoneNumberCard = (props: PhoneNumberCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePhoneChange = () => {
    props.onEdit(props.phoneData);
  };

  const handleConfirmPhoneDelete = () => {
    props.onDelete(props.phoneData);
    setIsModalOpen(false);
  };

  const getPhoneLocation = (val: number) => {
    return Object.keys(PhoneNumberType)[Object.values(PhoneNumberType).indexOf(val)];
  };

  return (
    <Card className={styles.smallCardDimensions}>
      <div className={styles.content}>
        <div className={styles.subtitleSmall}>
          {getPhoneLocation(props.phoneData.contactLocation)}
        </div>
        <div className={styles.phoneNumber}>{props.phoneData.formattedNumber}</div>
      </div>
      <div className={styles.footer}>
        <div className={styles.linkBlue} onClick={handlePhoneChange}>
          Edit
        </div>
      </div>
    </Card>
  );
};

export default PhoneNumberCard;
